import { client } from "api";
import { Company } from "models/Company";

export type CreateCompanyRequest = Pick<Company,
  "ueCode" |
  "name" |
  "orgNr" |
  "address" |
  "postalCode" |
  "city" |
  "latitude" |
  "longitude" |
  "region" |
  "contactName" |
  "phone" |
  "email" |
  "bookingEmail" |
  "hourlyRate" |
  "rating" |
  "ratingNotApplicable" |
  "kammarkollegietApproved" |
  "folderUrl" |
  "listedIn5620" |
  "competences"
>

export type CreateCompanyResponse = string;

export const createCompany = (request: CreateCompanyRequest): Promise<CreateCompanyResponse> =>
  client.post<CreateCompanyResponse>(`/company`, request).then((res) => res.data);
